export default "__VITE_ASSET__ffbe45c1__"